(() => {
  'use strict';

  const money = (raw) => {
    const value = Number(raw || 0);
    const amount = String(raw).includes('.') || String(raw).includes(',') ? value : value / 100;
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR',
    }).format(Number.isFinite(amount) ? amount : 0);
  };

  const handleFrom = (card) => {
    const match = (card?.getAttribute('href') || '').match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const canonicalProductHandle = (handle) => ({
    'deborah-campert-campert': 'deborah-campert-de-bloem',
    
  }[handle] || handle);

  let productsPromise;
  const productsByHandle = () => {
    if (productsPromise) return productsPromise;
    productsPromise = (async () => {
      const result = [];
      const root = window.Shopify?.routes?.root || '/';
      for (let page = 1; page <= 10; page += 1) {
        const response = await fetch(`${root}products.json?limit=250&page=${page}`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(`Shopify producten: ${response.status}`);
        const batch = (await response.json()).products || [];
        result.push(...batch);
        if (batch.length < 250) break;
      }
      return new Map(result.map((product) => [product.handle, product]));
    })();
    return productsPromise;
  };

  const cartIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 8.5h11l-1 10h-9l-1-10Zm2.5 0V6.7a3 3 0 0 1 6 0v1.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const buildHero = (page) => {
    const root = page.querySelector('#mb-auteurs, #mb-illustratoren');
    const intro = root?.querySelector(':scope > .mb-intro');
    const visual = root?.querySelector(':scope > .mb-visual');
    if (!root || !intro || !visual || root.querySelector(':scope > .mb-v126-maker-hero')) return;
    const hero = document.createElement('section');
    hero.className = 'mb-v126-maker-hero';
    root.insertBefore(hero, intro);
    hero.append(intro, visual);
  };

  const enhanceMakerCards = async (page) => {
    if (page.dataset.mbV126Overview === 'true') return;
    page.dataset.mbV126Overview = 'true';
    buildHero(page);

    let catalogue;
    try { catalogue = await productsByHandle(); }
    catch (error) {
      console.error('MatchBoox makersoverzicht kon de productgegevens niet laden.', error);
      return;
    }

    page.querySelectorAll('.mb-author-block, .mb-illustrator-block').forEach((block) => {
      const maker = block.querySelector('.mb-author-head h3, .mb-illustrator-head h3')?.textContent.trim() || '';
      const footer = document.createElement('div');
      footer.className = 'mb-v126-maker-footer';
      footer.innerHTML = `<span class="mb-v126-maker-price"></span><button type="button" class="mb-quick-add" data-mb-quick-add data-default-label="Toevoegen aan winkelmandje" aria-label="Toevoegen aan winkelmandje" title="Toevoegen aan winkelmandje">${cartIcon}</button>`;
      block.appendChild(footer);

      const update = () => {
        const active = block.querySelector('.mb-book-card.is-active') || block.querySelector('.mb-book-card');
        if (!active) return;
        let makerName = active.querySelector('.mb-v126-maker-name');
        if (!makerName) {
          makerName = document.createElement('span');
          makerName.className = 'mb-v126-maker-name';
          active.querySelector('.mb-book-meta')?.appendChild(makerName);
        }
        makerName.textContent = maker;
        const originalHandle = handleFrom(active);
        const handle = canonicalProductHandle(originalHandle);
        if (originalHandle !== handle) active.href = `${window.Shopify?.routes?.root || '/'}products/${handle}`;
        const product = catalogue.get(handle);
        const formattedPrice = money(product?.variants?.[0]?.price ?? product?.price ?? 0);
        footer.querySelector('.mb-v126-maker-price').textContent = formattedPrice;
        const button = footer.querySelector('[data-mb-quick-add]');
        button.dataset.productHandle = handle;
        button.dataset.productPrice = formattedPrice;
        const buttonPrice = button.querySelector('.mb-price-cart-button__price');
        if (buttonPrice) buttonPrice.textContent = formattedPrice;
        button.disabled = !handle;
      };

      update();
      block.querySelectorAll('.mb-book-card').forEach((card) => {
        new MutationObserver(update).observe(card, { attributes: true, attributeFilter: ['class'] });
      });
      block.querySelector('.mb-carousel-nav')?.addEventListener('click', () => window.setTimeout(update, 0));
    });
  };

  const repairFeaturedHeight = (scope = document) => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    scope.querySelectorAll?.('.section-matchboox-home [data-mb40-featured-track]').forEach((track) => {
      track.style.removeProperty('height');
    });
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.('.mb-page-content[data-page-handle="auteurs"], .mb-page-content[data-page-handle="illustratoren"]')
      .forEach(enhanceMakerCards);
    repairFeaturedHeight(scope);
    window.setTimeout(() => repairFeaturedHeight(scope), 450);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  window.addEventListener('load', () => repairFeaturedHeight(), { once: true });
  window.addEventListener('resize', () => repairFeaturedHeight(), { passive: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
